import { Injectable, signal } from '@angular/core';

export interface ToastMessage {
  id: string;
  header: string;
  subheader: string;
  message: string;
  variant: 'information' | 'success' | 'warning' | 'error';
  duration?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  // 使用 signal 替代普通属性
  toast = signal<ToastMessage | null>(null);
  show = signal(false);

  showToast(variant: ToastMessage['variant'] = 'information', header: string, subheader: string, message: string, duration?: number) {
    const id = Date.now().toString();
    this.toast.set({ id, message, variant, header, subheader, duration });
    this.show.set(true);
    
    // 自动移除 toast
    if (duration && duration > 0) {
      setTimeout(() => this.show.set(false), duration);
    }
  }

  showSuccess(message: string) {
    this.showToast('success', 'Success!', 'OK', message, 5000);
  }

  showError(header: string, subheader: string, message: string, ) {
    this.showToast('error', header, subheader,message);
  }

  showWarning(header: string, subheader: string, message: string) {
    this.showToast('warning', header, subheader, message, 5000);
  }

  showInfo(message: string, header: string, subheader: string) {
    this.showToast( 'information', header, subheader, message, 5000);
  }

  // 添加手动关闭方法
  hideToast() {
    this.show.set(false);
  }
}